<template>
  <div>
    <vuex-table
      :fields="fields"
      :auto_start="true"
      table_store="prices/rates/table"
      :tooltip_text="$t('prices.common.info.billing_terms_tooltip')"
    >
      <template slot="billingTerms" slot-scope="{ item }">
        {{ item.mc }} / {{ item.ci }} / {{ item.ft }}
      </template>
    </vuex-table>
  </div>
</template>

<script>
  import { toUserDateWithTime } from '@shared/helpers/date_format';
  import { oneOf } from 'view-design/src/utils/assist';
  import {
    SERVICES,
    isSmsVerificationService,
    isVoiceService,
    isVoiceVerificationService
  } from '@utils/services';
  import { mapActions, mapGetters } from 'vuex';

  export default {
    props: {
      type: {
        type: [String, undefined],
        required: true,
        validator: (value) => oneOf(value, SERVICES)
      },
      table_store: {
        type: String,
        default: ''
      }
    },

    computed: {
      ...mapGetters('prices/rates/table', ['sort_direction']),

      show_billing_terms: function () {
        return isVoiceService(this.type) || isVoiceVerificationService(this.type);
      },
      fields: function () {
        const columns = {
          display_name: {
            key: 'display_name',
            label: this.$t('prices.common.field.name'),
            sortable: true,
            class: 'w-30'
          },
          mcc: {
            key: 'mcc',
            label: this.$t('prices.common.field.mcc'),
            sortable: true,
            class: 'w-10'
          },
          mnc: {
            key: 'mnc',
            label: this.$t('prices.common.field.mnc'),
            sortable: true,
            class: 'w-10'
          },
          code: {
            key: 'code',
            label: this.$t('prices.common.field.code'),
            sortable: false,
            class: 'w-10',
            formatter: (value) => (value ? value : '–')
          },
          start: {
            key: 'start',
            label: this.$t('prices.common.field.date_start'),
            sortable: true,
            formatter: (value) => toUserDateWithTime(value),
            class: 'w-20',
            thStyle: {
              minWidth: '100px'
            }
          },
          end: {
            key: 'end',
            label: this.$t('prices.common.field.date_end'),
            sortable: true,
            formatter: (value) => toUserDateWithTime(value),
            class: 'w-20',
            thStyle: {
              minWidth: '100px'
            }
          },
          price: {
            key: 'price',
            label: this.$t('prices.common.field.price'),
            sortable: true,
            class: 'w-10',
            formatter: (value) => this.$numeral.currency(value),
            thStyle: {
              minWidth: '100px'
            }
          },
          billing_terms: {
            key: 'billingTerms',
            label: this.$t('prices.common.field.billing_terms') + ' (mc/ci/ft)',
            class: 'w-10',
            formatter: (value) => {
              return value;
            },
            thStyle: {
              minWidth: '20px'
            }
          }
        };

        if (this.type === 'sms' || isSmsVerificationService(this.type)) {
          return [
            columns.display_name,
            columns.mcc,
            columns.mnc,
            columns.start,
            columns.end,
            columns.price
          ];
        } else if (this.type === 'hlr') {
          return [columns.display_name, columns.mcc, columns.start, columns.end, columns.price];
        }
        return [
          columns.display_name,
          columns.code,
          columns.start,
          columns.end,
          columns.price,
          columns.billing_terms
        ];
      }
    },
    methods: {
      ...mapActions('prices/rates/table', ['changeSort']),
    }
  };
</script>
